var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "styleConfig" },
    [
      !_vm.disabled
        ? _c("div", { staticClass: "pageTitle" }, [
            _c("span", { staticClass: "left" }, [
              _vm._v(" 商城风格设置 - "),
              _vm.isCustomer
                ? _c(
                    "span",
                    [
                      _vm._v(" " + _vm._s(_vm.info.customer_name) + " "),
                      _vm.info.customer_name.indexOf("*") != -1
                        ? _c(
                            "el-button",
                            {
                              staticStyle: {
                                padding: "0",
                                "margin-left": "8px",
                              },
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.watchCustomerName("1")
                                },
                              },
                            },
                            [_vm._v("查看")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _c(
                    "span",
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.info.short_name || _vm.info.company_name) +
                          " " +
                          _vm._s(_vm.info.module === "admin" ? "(渠道)" : "") +
                          " "
                      ),
                      _vm._l(_vm.fieldsToCheck, function (field) {
                        return _c(
                          "span",
                          { key: field.key },
                          [
                            _vm.shouldShowButton(_vm.info[field.key])
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.watchCustomerName(field.type)
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(field.label) + " ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
            ]),
            _c("div", { staticClass: "right" }, [
              _vm.$hasBtnRoles(
                {
                  admin: "/decoration/decoration/get-decoration-log",
                  custom: "/decoration/decoration/get-customer-decoration-log",
                  plat_custom: "/plat/decoration/get-customer-decoration-log",
                  channel: "/decoration/decoration/get-shop-decoration-log",
                }[_vm.info.module]
              )
                ? _c(
                    "span",
                    { staticClass: "log", on: { click: _vm.getLogData } },
                    [
                      _c("i", { staticClass: "el-icon el-icon-s-order" }),
                      _vm._v(" 操作日志 "),
                    ]
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _c(
        "el-card",
        { staticClass: "card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                disabled: _vm.disabled,
                "label-width": "150px",
                "label-suffix": ":",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商城首页标题", prop: "home_index_name" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isSaleEditBannerMode,
                      placeholder: "请输入",
                      clearable: "",
                      "show-word-limit": "",
                      maxlength: "10",
                    },
                    model: {
                      value: _vm.formData.home_index_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "home_index_name", $$v)
                      },
                      expression: "formData.home_index_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "home_style",
                  attrs: { label: "首页风格", prop: "home_style" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.changeHomeStyle },
                      model: {
                        value: _vm.formData.home_style,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "home_style", $$v)
                        },
                        expression: "formData.home_style",
                      },
                    },
                    [
                      _vm.isCustomer
                        ? [
                            _c(
                              "el-radio",
                              { attrs: { label: "channel_style" } },
                              [
                                _vm._v(" 使用渠道风格及配置 "),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        "完全继承渠道的风格和配置，当渠道为自定义风格且有多套商城时，可选择继承哪套商城",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-warning-outline",
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-radio",
                              { attrs: { label: "channel_style_or_defined" } },
                              [
                                _vm._v(" 使用渠道风格，个性化配置 "),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        "继承渠道的装修风格，配置客户自己的登录方式、默认登录页、展示方式和Banner图等；当渠道为自定义风格且有多套商城时，可选择继承哪套",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-warning-outline",
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _c(
                        "el-radio",
                        { attrs: { label: "user_defined" } },
                        [
                          _vm._v(" 自定义风格 "),
                          _vm.isCustomer
                            ? _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content:
                                      "客户自己装修商城，独立设置装修配置，跟渠道无关",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-warning-outline",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("el-radio", { attrs: { label: "shop" } }, [
                        _vm._v("商城风格"),
                      ]),
                      _c("el-radio", { attrs: { label: "work" } }, [
                        _vm._v("SaaS风格"),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
              ["channel_style", "channel_style_or_defined"].includes(
                _vm.formData.home_style
              )
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "main_style_id",
                      attrs: { prop: "main_style_id" },
                    },
                    [
                      _c("div", [_vm._v("选择继承的模板")]),
                      _c(
                        "div",
                        {
                          class: [
                            "mainTempContent",
                            _vm.disabled && "disabled",
                          ],
                        },
                        _vm._l(_vm.mainTempList, function (temp) {
                          return _c(
                            "div",
                            {
                              key: temp.id,
                              class: [
                                "temp",
                                temp.id == _vm.formData.main_style_id && "main",
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.changeMainTemp(temp)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "temp-item-content" }, [
                                _c("div", { staticClass: "title-header" }, [
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v(_vm._s(temp.name || "— —")),
                                  ]),
                                  _c("div", { staticClass: "id" }, [
                                    _vm._v(_vm._s(temp.id)),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "img" },
                                  [
                                    _c(
                                      "el-image",
                                      { attrs: { src: temp.thumb } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "loading",
                                            attrs: { slot: "placeholder" },
                                            slot: "placeholder",
                                          },
                                          [_vm._v("加载中...")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  class: [
                                    "title",
                                    temp.current ? "current" : "select",
                                  ],
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        temp.current
                                          ? "当前应用模板"
                                          : "选择该模版"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.formData.home_style !== "channel_style"
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "商城首页展示逻辑",
                          prop: "home_show_mode",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: _vm.isSaleEditBannerMode },
                            model: {
                              value: _vm.formData.home_show_mode,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "home_show_mode", $$v)
                              },
                              expression: "formData.home_show_mode",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("先登录后展示"),
                            ]),
                            _c(
                              "el-radio",
                              {
                                attrs: {
                                  label: "2",
                                  disabled: ["shop", "work"].includes(
                                    _vm.formData.home_style
                                  ),
                                },
                              },
                              [
                                _vm._v(" 先展示后登录 "),
                                _c("span", { staticClass: "tips" }, [
                                  _vm._v(
                                    " （即首页支持游客模式浏览查看，用户进入不支持游客模式的页面时跳转登录页） "
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商城登录方式", prop: "login_type" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: _vm.isSaleEditBannerMode },
                            on: { change: _vm.changeLoginType },
                            model: {
                              value: _vm.formData.login_type,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "login_type", $$v)
                              },
                              expression: "formData.login_type",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("手机号+验证码"),
                            ]),
                            _c("el-radio", { attrs: { label: "2" } }, [
                              _vm._v("手机号+绑卡"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "C端商城默认登录页",
                          prop: "login_type_c",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: _vm.isSaleEditBannerMode },
                            model: {
                              value: _vm.formData.login_type_c,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "login_type_c", $$v)
                              },
                              expression: "formData.login_type_c",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("手机号验证码登录页"),
                            ]),
                            _c("el-radio", { attrs: { label: "2" } }, [
                              _vm._v("卡号+密码登录页"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "页面展示方式",
                          prop: "home_data_rule",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: _vm.isSaleEditBannerMode },
                            model: {
                              value: _vm.formData.home_data_rule,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "home_data_rule", $$v)
                              },
                              expression: "formData.home_data_rule",
                            },
                          },
                          [
                            _c(
                              "el-radio",
                              {
                                attrs: {
                                  label: "1",
                                  disabled: ["shop", "work"].includes(
                                    _vm.formData.home_style
                                  ),
                                },
                              },
                              [
                                _vm._v(" 开放式 "),
                                _c("span", { staticClass: "tips" }, [
                                  _vm._v(
                                    " （不论是否绑卡、卡规则支持哪些功能，展示全部功能模块） "
                                  ),
                                ]),
                              ]
                            ),
                            _c("el-radio", { attrs: { label: "2" } }, [
                              _vm._v(" 封闭式 "),
                              _c("span", { staticClass: "tips" }, [
                                _vm._v(
                                  " （仅展示用户卡规则支持的模块，不支持的模块隐藏） "
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.formData.home_style === "channel_style_or_defined"
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "商城首页Banner图",
                          prop: "customer_home_banner_type",
                        },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: !_vm.canEditBanner },
                            model: {
                              value: _vm.formData.customer_home_banner_type,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "customer_home_banner_type",
                                  $$v
                                )
                              },
                              expression: "formData.customer_home_banner_type",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "0" } }, [
                              _vm._v("使用渠道的Banner图"),
                            ]),
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("自己配置Banner图"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.formData.customer_home_banner_type === "1"
                      ? [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-plus",
                                disabled: !_vm.canEditBanner,
                              },
                              on: { click: _vm.addUpload },
                            },
                            [_vm._v(" 新增轮播图 ")]
                          ),
                          _c(
                            "div",
                            { staticClass: "banner-box" },
                            _vm._l(
                              _vm.formData.customer_home_banner.value,
                              function (item, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "upload-item" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "banner-header" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "item-title" },
                                          [_vm._v("轮播图" + _vm._s(index + 1))]
                                        ),
                                        !_vm.disabled && _vm.canEditBanner
                                          ? _c("i", {
                                              staticClass:
                                                "el-icon el-icon-delete",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDelete(index)
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "upload" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "customer_home_banner.value." +
                                                index +
                                                ".imageurl",
                                              rules: [
                                                {
                                                  required: true,
                                                  message: "图片不可为空",
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "upload-item-wrap",
                                              },
                                              [
                                                _c("upload-file", {
                                                  ref: "uploadBanner",
                                                  refInFor: true,
                                                  attrs: {
                                                    "link-url": _vm.linkUrl,
                                                    tempurl: item.imageurl,
                                                    disabled:
                                                      _vm.disabled ||
                                                      !_vm.canEditBanner,
                                                  },
                                                  on: {
                                                    emitUploadFile: function (
                                                      res
                                                    ) {
                                                      return _vm.emitUploadFile(
                                                        res,
                                                        item
                                                      )
                                                    },
                                                  },
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "btns" },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            !_vm.canEditBanner,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.onUpload(
                                                              index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(" 上传图片 ")]
                                                    ),
                                                    _vm.pictureList.length > 0
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary",
                                                              disabled:
                                                                !_vm.canEditBanner,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.selectPicture(
                                                                  index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v(" 选择图片 ")]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio-group",
                                          {
                                            attrs: {
                                              disabled: !_vm.canEditBanner,
                                            },
                                            on: {
                                              change: function (res) {
                                                return _vm.radioChange(
                                                  res,
                                                  item
                                                )
                                              },
                                            },
                                            model: {
                                              value: item.link_type,
                                              callback: function ($$v) {
                                                _vm.$set(item, "link_type", $$v)
                                              },
                                              expression: "item.link_type",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: "1" } },
                                              [_vm._v("选菜单")]
                                            ),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: "2" } },
                                              [_vm._v("输入链接")]
                                            ),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: "3" } },
                                              [_vm._v("子页面")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    item.link_type == "1"
                                      ? _c(
                                          "el-form-item",
                                          [
                                            _c("el-cascader", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                disabled: !_vm.canEditBanner,
                                                options: _vm.menuList,
                                                "collapse-tags": "",
                                                props: {
                                                  label: "show_name",
                                                  value: "id",
                                                  children: "childrens",
                                                  checkStrictly: true,
                                                  emitPath: false,
                                                },
                                                clearable: "",
                                                placeholder: "选择菜单",
                                              },
                                              model: {
                                                value: item.link_value,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "link_value",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.link_value",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    item.link_type == "2"
                                      ? _c(
                                          "div",
                                          { staticClass: "size-title" },
                                          [
                                            _c(
                                              "el-form-item",
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "请输入链接",
                                                    disabled:
                                                      !_vm.canEditBanner,
                                                  },
                                                  model: {
                                                    value: item.link_value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "link_value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.link_value",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    item.link_type == "3"
                                      ? _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  disabled: !_vm.canEditBanner,
                                                  placeholder: "请选择子页面",
                                                  clearable: "",
                                                  filterable: "",
                                                },
                                                model: {
                                                  value: item.link_value,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "link_value",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.link_value",
                                                },
                                              },
                                              _vm._l(
                                                _vm.childrenMenuList,
                                                function (
                                                  childMenu,
                                                  child_index
                                                ) {
                                                  return _c("el-option", {
                                                    key: child_index,
                                                    attrs: {
                                                      label:
                                                        childMenu.name +
                                                        "（" +
                                                        childMenu.id +
                                                        "）",
                                                      value:
                                                        childMenu.page_unique_key,
                                                      disabled:
                                                        childMenu.status +
                                                          "" !==
                                                        "0",
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      : _vm._e(),
                  ]
                : _vm._e(),
              !_vm.disabled
                ? _c(
                    "el-form-item",
                    [
                      _vm.showSaveButton
                        ? _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.saveConfig },
                            },
                            [_vm._v(" 保存 ")]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        { staticClass: "btn", on: { click: _vm.goBack } },
                        [_vm._v("返回")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            top: "20px",
            width: "70%",
            title: "查看操作日志",
            "lock-scroll": "",
            visible: _vm.dialogShow,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogShow = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            { ref: "dialogForm", attrs: { model: _vm.dialogForm, inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "operate_time", label: "操作时间" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "value-format": "yyyy-MM-dd",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                    },
                    model: {
                      value: _vm.dialogForm.operate_time,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm, "operate_time", $$v)
                      },
                      expression: "dialogForm.operate_time",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "operator_id", label: "操作人" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.dialogForm.operator_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.dialogForm, "operator_id", $$v)
                        },
                        expression: "dialogForm.operator_id",
                      },
                    },
                    _vm._l(_vm.sellUserList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getLogData } },
                [_vm._v("搜索")]
              ),
              _c("el-button", { on: { click: _vm.resetForm } }, [
                _vm._v("重置"),
              ]),
            ],
            1
          ),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.logList,
                "header-cell-style": {
                  background: "#f1f1f1",
                  color: "#333333",
                },
                height: "60vh",
              },
            },
            [
              _c("el-table-column", {
                attrs: { width: "80px", prop: "id", label: "编号" },
              }),
              _c("el-table-column", {
                attrs: { prop: "note", "min-width": "300px", label: "内容" },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "170px",
                  prop: "create_time",
                  label: "操作时间",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150px",
                  prop: "operator_name",
                  label: "操作人",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px", "text-align": "right" } },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, prev, pager, next, jumper",
                  "current-page": _vm.dialogForm.page,
                  "page-size": _vm.dialogForm.page_size,
                  total: _vm.totalCount,
                },
                on: { "current-change": _vm.getLogData },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogShow = false
                    },
                  },
                },
                [_vm._v(" 关闭 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: { widget: "banner轮播图" },
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }